import React from 'react';
import './Css/DataTableDemo.css';
import moment from 'moment/min/moment-with-locales';

const formatCurrency = (value) => {
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
};
export function IdBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Id</span>
            {rowData.Id}
        </React.Fragment>
    );
}

export function InscricaoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Inscrição </span>
            {rowData.Inscricao}
        </React.Fragment>
    );
}
export function AssociadoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Nome Associado</span>
            {rowData.NomeAssociado}
        </React.Fragment>
    );
}
export function CidadeBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Cidade </span>
            {rowData.NomeCidade}
        </React.Fragment>
    );
}
export function PagamentoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Pagamento </span>
            {rowData.Pagamento}
        </React.Fragment>
    );
}
export function ValorCremacaoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Valor Cremação </span>
            {formatCurrency(rowData.ValorCremacao)}
        </React.Fragment>
    );
}
export function ValorPagoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Valor Pago </span>
            {formatCurrency(rowData.ValorPago)}
        </React.Fragment>
    );
}
export function ValorComissaoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Comissão </span>
            {formatCurrency(rowData.ValorComissao)}
        </React.Fragment>
    );
}
export function PercentualBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">% Comissão</span>
            {rowData.PercentualComissao}
        </React.Fragment>
    );
}
export function PlanoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Plano</span>
            {rowData.SubGrupo}
        </React.Fragment>
    );
}
export function TipoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Tipo</span>
            {rowData.Tipo}
        </React.Fragment>
    );
}
export function TotalBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Total</span>
            {rowData.Total}
        </React.Fragment>
    );
}
export function AceiteBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Aceite</span>
            {rowData.aceite}
        </React.Fragment>
    );
}
export function FonteBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Fonte Portal</span>
            {rowData.FonteInformacao}
        </React.Fragment>
    );
}
export function SupervisorBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Supervisores</span>
            {rowData.NomeSupervisor}
        </React.Fragment>
    );
}

export function bodyTotalComissaoGerente(rowData) {
    return `${formatCurrency(rowData.TotalComissaoGerente)}`;
}
export function bodyCommissaoVendedor(rowData) {
    return `${formatCurrency(rowData.TotalComissao)}`;
}

export const bodyTotalComissaoCoordenador = (rowData) => {
    return `${formatCurrency(rowData.TotalComissaoCoordenador)}`;
};

export const bodyPagamento = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Pagamento</span>
            {moment(rowData.Pagamento).format('DD/MM/YYYY')}
        </React.Fragment>
    );
};
export const bodyTotalComissaoSupervisor = (rowData) => {
    return `${formatCurrency(rowData.TotalComissaoSupervisor)}`;
};

export function bodyValorComissaoVendedor(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Valor Comissão</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(rowData.ValorComissao)}
        </React.Fragment>
    );
}

export function bodyComissaoCoordenador(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Coordenador</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(rowData.ValorComissaoCoordenador)}
        </React.Fragment>
    );
}
export function bodyValorPagoVendedor(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Valor Pago</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(rowData.ValorPago)}
        </React.Fragment>
    );
}
